(function () {
    const SELECTED_EVENT = 'AppstleSubscription:SubscriptionWidget:SellingPlanSelected';
    const DESELECTED_EVENT = 'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected';
    const CHANGED_EVENT = 'AppstleSubscription:SubscriptionWidget:sellingPlanChanged';

    function selectInitialVariant(form, variantSelect) {
        const wrapper = form.querySelector('.variant-wrapper[data-initial-variant-id]');

        if (!wrapper || wrapper.dataset.type !== 'select') {
            return;
        }

        const groups = wrapper.querySelectorAll('.variant-group');

        groups.forEach(function (group, index) {
            const value = wrapper.dataset[`initialOption-${index + 1}`];

            if (!value) {
                return;
            }

            group.value = value;
            group.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (variantSelect.value !== wrapper.dataset.initialVariantId) {
            return;
        }

        const cleanUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
    }

    function initSubscriptionPrice() {
        const form = document.querySelector('.product-form-main');

        if (!form || form.dataset.subscriptionPriceInitialized === 'true') {
            return;
        }

        const variantSelect = form.querySelector('select[name="id"]');

        if (!variantSelect) {
            return;
        }

        selectInitialVariant(form, variantSelect);

        const priceContainer = form.querySelector('.product-details__price');
        const money = priceContainer && priceContainer.querySelector('[itemprop="price"]');
        const label = priceContainer && priceContainer.querySelector('[data-pdp-price-label]');
        const compare = priceContainer && priceContainer.querySelector('.compare');
        const floatingPriceContainer = document.querySelector('.floating-form__price');
        const floatingMoney = floatingPriceContainer && floatingPriceContainer.querySelector('[itemprop="price"]');
        const floatingCompare = floatingPriceContainer && floatingPriceContainer.querySelector('.compare');

        if (!priceContainer || !money) {
            return;
        }

        let subscriptionSelected = Boolean(label && money.dataset.subscriptionPrice !== undefined);
        let renderFrame;

        function getSelectedVariant() {
            return variantSelect.options[variantSelect.selectedIndex];
        }

        function getPriceData() {
            const selectedVariant = getSelectedVariant();
            const variantData = selectedVariant ? selectedVariant.dataset : {};

            return {
                price: Number(variantData.price || money.dataset.original || 0),
                compareAtPrice: Number(variantData.compare || 0),
                subscriptionPrice: Number(
                    variantData.subscriptionPrice || money.dataset.subscriptionPrice || 0
                ),
            };
        }

        function renderPrice() {
            if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') {
                queuePriceRender();
                return;
            }

            const { price, compareAtPrice, subscriptionPrice } = getPriceData();
            const showSubscriptionPrice = subscriptionSelected && subscriptionPrice > 0;

            priceContainer.style.display = 'flex';

            if (showSubscriptionPrice) {
                if (label) {
                    label.textContent = 'From ';
                    label.style.display = 'inline-block';
                }

                money.textContent = Shopify.formatMoney(subscriptionPrice, Shopify.money_format);

                if (floatingMoney) {
                    floatingMoney.textContent = `From ${Shopify.formatMoney(subscriptionPrice, Shopify.money_format)}`;
                }

                if (compare) {
                    compare.innerHTML = '';
                }

                if (floatingCompare) {
                    floatingCompare.innerHTML = '';
                }

                return;
            }

            if (label) {
                label.style.display = 'none';
            }

            if (compareAtPrice > price) {
                money.innerHTML = `<ins>${Shopify.formatMoney(price, Shopify.money_format)}</ins>`;

                if (floatingMoney) {
                    floatingMoney.innerHTML = `<ins>${Shopify.formatMoney(price, Shopify.money_format)}</ins>`;
                }

                if (compare) {
                    compare.innerHTML = `<del>${Shopify.formatMoney(compareAtPrice, Shopify.money_format)}</del>`;
                }

                if (floatingCompare) {
                    floatingCompare.innerHTML = `<del>${Shopify.formatMoney(compareAtPrice, Shopify.money_format)}</del>`;
                }
            } else {
                money.textContent = Shopify.formatMoney(price, Shopify.money_format);

                if (floatingMoney) {
                    floatingMoney.textContent = Shopify.formatMoney(price, Shopify.money_format);
                }

                if (compare) {
                    compare.innerHTML = '';
                }

                if (floatingCompare) {
                    floatingCompare.innerHTML = '';
                }
            }
        }

        function queuePriceRender() {
            window.cancelAnimationFrame(renderFrame);
            renderFrame = window.requestAnimationFrame(renderPrice);
        }

        variantSelect.addEventListener('change', queuePriceRender);

        document.addEventListener(SELECTED_EVENT, function () {
            subscriptionSelected = true;
            queuePriceRender();
        });

        document.addEventListener(DESELECTED_EVENT, function () {
            subscriptionSelected = false;
            queuePriceRender();
        });

        document.addEventListener(CHANGED_EVENT, function () {
            subscriptionSelected = true;
            queuePriceRender();
        });

        form.dataset.subscriptionPriceInitialized = 'true';
        queuePriceRender();
    }

    if (document.readyState === 'complete') {
        initSubscriptionPrice();
    } else {
        document.addEventListener('DOMContentLoaded', initSubscriptionPrice);
    }
})();
